import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  approveBill,
  exportBills,
  getBillExportStatus,
  getBillList,
  getBillRejectReasonList,
} from 'app/api/bill';
import { startExportPoll, triggerDownload } from 'app/utils/exportPoller';
import { getMallList } from 'app/api/mall';
import { getStoreListOnMallID } from 'app/api/store';
import { APP_CONSTANTS, LocalSessionKey } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import { dataformatChangesYearToDate } from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
import { LocalStorage } from 'app/utils/storage';
import { isOtherReason } from './rejectionReason';

const useBillManagement = () => {
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false); // New state to track filtering
  const [values, setValues] = useState({
    mallId: '',
    storeId: '',
    phoneNumber: '',
    billStatus: '',
    invoice_number: '',
    invoice_dateStart: '',
    invoice_dateEnd: '',
  });
  // Ref guards double-fire synchronously (state updates are async); state
  // drives the dimmed-icon UI while the export job runs.
  const downloadInProgressRef = useRef(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const sectionObj = {
    sectionTitle: 'Bill Management',
    searchObj: {
      keys: ['invoice_number', 'shopping_amount', 'storeName', 'phoneNumber'],
      placeholder: 'Search by Contact No, Bill No , Mall name, Store Name',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);

        // inputChangeHandler(e);
      },
    },
    buttons: [
      {
        customclassName: 'bg-white margin-right-class',
        imgTrue: false,
        title: 'Filter',
        handleBtnClick: () => {
          setIsFilterOpen(!isFilterOpen);
        },
      },
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_BILL_VALIDATION_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_BILL_VALIDATION}`);
        },
      },
    ],
    // Excel only — no csvClick, so SectionHeader renders just the xls icon.
    downloadObj: {
      excelClick: () => {
        startDownload();
      },
      inProgress: downloadInProgress,
    },
  };
  const navigate = useNavigate();
  const [error, setErrors] = useState({});
  const [totalNumber, setTotalNumber] = useState(0);
  const [modelvalues, setmodelValues] = useState({
    rejectionReason: '',
    rejectionNote: '',
    mallId: '',
    storeId: '',
    invoice_number: '',
    shopping_amount: '',
    name: '',
    phoneNumber: '',
    invoice_date: dataformatChangesYearToDate(new Date()),
    brand_name: '',
    category_name: '',
  });
  const [modlopen, setOpenModel] = useState(false);
  const [rejectStatus, setrejectStatus] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  // Approve/Reject in-flight guard. The ref blocks a second click fired
  // before React re-renders; the state disables the popup buttons.
  const billActionInFlightRef = useRef(false);
  const [billActionInFlight, setBillActionInFlight] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 10;
  const [mallList, setMallList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [billrejectReson, setBillRejectReson] = useState([]);

  async function getStoreListDropdown(value) {
    let response = await getStoreListOnMallID(value);

    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.storeName,
        };
      });
      setStoreList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  async function billrejectReasonDropdown(value) {
    setPageLoading(true);
    let response = await getBillRejectReasonList(value);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = response?.data?.map((item, index) => {
        return {
          ...item,
          value: item.label,
        };
      });
      setBillRejectReson(temp);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  const fetchBillData = useCallback(
    async (page, searchValue = '', filters = {}) => {
      setPageLoading(true);
      try {
        let requestParam = {
          page,
          limit: dataPerPage,
          search: searchValue,
          mallId: filters.mallId,
          storeId: filters.storeId,
          phoneNumber: filters.phoneNumber,
          billStatus: filters.billStatus,
          invoice_number: filters.invoice_number,
          invoice_dateStart: filters.invoice_dateStart,
          invoice_dateEnd: filters.invoice_dateEnd,
        };
        const response = await getBillList(requestParam); // Pass searchValue to API call
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.bills || [];
          const newArray = dataArr.map((item) => ({
            ...item,
            billStatus: item?.bill?.billStatus,
            invoice_number: item?.bill?.invoice_number,
            shopping_amount: item?.bill?.shopping_amount,
            name: item?.customer?.name,
            phoneNumber: item?.customer?.phoneNumber,
            invoice_date: dataformatChangesYearToDate(item?.bill?.invoice_date),
            storeName: item?.store?.name,
            category_name: item?.category?.name,
            mallId: item?.mall?.id,
            mallName: item?.mall?.name,
            storeId: item?.store?.id,
          }));
          setData(newArray);
          setFilteredData(newArray);

          const totalCount = response?.data?.total || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );
  async function handleNew(data) {
    // 260929-omp: every open starts with a clean reason/note so a stale
    // typed note never leaks into a different bill's reject flow.
    setmodelValues({ ...data, rejectionReason: '', rejectionNote: '' });
    try {
      const mallListPromise = getMallListForDropdown();
      const storeListPromise = data?.mallId
        ? getStoreListDropdown(data.mallId)
        : Promise.reject('No Mall Selected');

      await Promise.all([mallListPromise, storeListPromise]);

      setOpenModel(true);
    } catch (error) {
      Toast.error(error);
    }
  }
  const handlemodelvalues = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setmodelValues({
        ...modelvalues,
        [name]: name === 'shopping_amount' ? parseInt(value) : value,
        // 260929-omp: switching away from Other/Others clears any typed
        // note so it never resurfaces (unsent) if the admin picks Other again.
        ...(name === 'rejectionReason' && !isOtherReason(value)
          ? { rejectionNote: '' }
          : {}),
      });
      if (error[name]) {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
      }
    }
  };
  const handleMallChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setStoreList([]);
      getStoreListDropdown(value);
      setmodelValues({ ...modelvalues, [name]: value, storeId: '' });
    }
  };
  const handleMallChangefilter = (e) => {
    if (e && e.target) {
      const { value } = e.target;
      setStoreList([]);
      getStoreListDropdown(value);
      setValues({ ...values, mallId: value, storeId: '' });
    }
  };
  const getMallListForDropdown = async () => {
    setPageLoading(true);
    try {
      const response = await getMallList(1);
      if (response?.responseCode === 200) {
        const temp = response?.data?.malls?.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        setMallList(temp);
      } else {
        Toast.error(response?.data || Message.Error.COMMON_MESSAGE);
      }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      setPageLoading(false);
    }
  };
  const approveBillManagement = async () => {
    if (billActionInFlightRef.current) return;
    billActionInFlightRef.current = true;
    setBillActionInFlight(true);
    setPageLoading(true);
    try {
      let data = {
        customerId: modelvalues?.customer?.id,
        invoice_date: modelvalues?.invoice_date,
        mallId: modelvalues?.mallId,
        storeId: modelvalues?.storeId,
        invoice_number: modelvalues?.invoice_number,
        shopping_amount: modelvalues?.shopping_amount,
        approvedBy: user?.id,
        status: 2,
      };

      const response = await approveBill(modelvalues?.bill?.id, 'approve', {
        ...data,
        status: 2,
      });
      if (response?.responseCode === 200) {
        fetchBillData(currentPage);
        setrejectStatus(false);
        setOpenModel(false);
        Toast.success('Bill Approved Successfully');
      } else {
        Toast.error(
          response?.response?.message || Message.Error.COMMON_MESSAGE
        );
      }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      billActionInFlightRef.current = false;
      setBillActionInFlight(false);
      setPageLoading(false);
    }
  };
  const rejectBillManagement = async () => {
    if (billActionInFlightRef.current) return;
    billActionInFlightRef.current = true;
    setBillActionInFlight(true);
    setPageLoading(true);
    try {
      let data = {
        customerId: modelvalues?.customer?.id,
        invoice_date: modelvalues?.invoice_date,
        mallId: modelvalues?.mallId,
        storeId: modelvalues?.storeId,
        invoice_number: modelvalues?.invoice_number,
        shopping_amount: modelvalues?.shopping_amount,
        status: 3,
        // 260929-omp: Other/Others -> send the trimmed typed note instead
        // of the placeholder word; any other reason is sent unchanged.
        rejectionReason: isOtherReason(modelvalues?.rejectionReason)
          ? modelvalues?.rejectionNote?.trim()
          : modelvalues?.rejectionReason,
        approvedBy: user?.id,
      };
      const response = await approveBill(modelvalues?.bill?.id, 'reject', {
        ...data,
        status: 3,
        rejectionReason: data?.rejectionReason,
      });
      if (response?.responseCode === 200) {
        setrejectStatus(false);
        setOpenModel(false);
        fetchBillData(currentPage);
        Toast.success('Bill Rejected !!');
      } else {
        Toast.error(
          response?.response?.message || Message.Error.COMMON_MESSAGE
        );
      }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      billActionInFlightRef.current = false;
      setBillActionInFlight(false);
      setPageLoading(false);
    }
  };
  function handleFiltering() {
    try {
      if (!data || !Array.isArray(data)) {
        throw new Error('Data is not defined or not an array');
      }

      if (!values) {
        throw new Error('Values are not defined');
      }

      const filtered = data.filter((item) => {
        let isMallMatching =
          !values.mallName ||
          item?.mallName?.toLowerCase().includes(values.mallName.toLowerCase());

        let isStoreMatching =
          !values.storeName ||
          item?.storeName
            ?.toLowerCase()
            .includes(values.storeName.toLowerCase());

        let isPhoneMatching =
          !values.phoneNumber ||
          item?.phoneNumber?.includes(values.phoneNumber);

        let isStatusMatching =
          !values.billStatus ||
          item?.billStatus?.toString().includes(values.billStatus.toString());

        let isInvoiceNumberMatching =
          !values.invoice_number ||
          (item?.invoice_number &&
            item.invoice_number
              .toString()
              .includes(values.invoice_number.toString()));

        let isInvoiceDateStartMatching =
          !values.invoice_dateStart ||
          new Date(item?.invoice_date) >= new Date(values.invoice_dateStart);

        let isInvoiceDateEndMatching =
          !values.invoice_dateEnd ||
          new Date(item?.invoice_date) <= new Date(values.invoice_dateEnd);

        return (
          isMallMatching &&
          isStoreMatching &&
          isPhoneMatching &&
          isInvoiceNumberMatching &&
          isStatusMatching &&
          isInvoiceDateStartMatching &&
          isInvoiceDateEndMatching
        );
      });

      setFilteredData(filtered);
    } catch (error) {
      console.error('Error in handleFiltering:', error.message);
    }
  }

  function resetfilterModel() {
    setValues({
      mallId: '',
      storeId: '',
      phoneNumber: '',
      billStatus: '',
      invoice_number: '',
      invoice_dateStart: '',
      invoice_dateEnd: '',
    });
    setFilteredData([]);
    setIsFiltering(true);
  }

  function handleFilterCancel() {
    setIsFilterOpen(false);
  }

  // Async excel export: returns a jobId, then polls the bill-scoped
  // /bill/export-status/:jobId. We DON'T block the UI with pageLoading — the
  // Toast is enough feedback, and forcing a full-page loader prevents the
  // user from working while the export runs (can take minutes on large data).
  async function startDownload() {
    if (downloadInProgressRef.current) return;
    downloadInProgressRef.current = true;
    setDownloadInProgress(true);

    function finish() {
      downloadInProgressRef.current = false;
      setDownloadInProgress(false);
    }

    // Same filter fields fetchBillData sends, plus the live search term —
    // PaginationTable persists it to the ?search= URL param in sync with the
    // listing, so the exported file matches what's on screen.
    const requestParam = {
      search: new URLSearchParams(window.location.search).get('search') || '',
      mallId: values.mallId,
      storeId: values.storeId,
      phoneNumber: values.phoneNumber,
      billStatus: values.billStatus,
      invoice_number: values.invoice_number,
      invoice_dateStart: values.invoice_dateStart,
      invoice_dateEnd: values.invoice_dateEnd,
    };

    try {
      const response = await exportBills(requestParam);
      const jobId = response?.data?.jobId;
      if (response?.responseCode !== 200 || !jobId) {
        // Also surfaces the backend's "No data to export" message.
        Toast.error(
          response?.response?.message || Message.Error.COMMON_MESSAGE
        );
        finish();
        return;
      }

      Toast.success('Report generation started');

      startExportPoll(jobId, {
        getStatus: getBillExportStatus,
        onDone: (url) => {
          triggerDownload(url);
          finish();
        },
        onFailed: (error) => {
          Toast.error(error || Message.Error.COMMON_MESSAGE);
          finish();
        },
        onError: () => {
          Toast.error(Message.Error.COMMON_MESSAGE);
          finish();
        },
      });
    } catch (error) {
      console.error('startDownload failed:', error);
      Toast.error(Message.Error.COMMON_MESSAGE);
      finish();
    }
  }

  useEffect(() => {
    if (isFilterOpen) {
      getMallListForDropdown();
    }
  }, [isFilterOpen]);

  // 260929-omp: clear rejectionReason/rejectionNote whenever the modal
  // closes (X button, approve success, reject success) so the next open
  // never shows stale reject-flow state.
  useEffect(() => {
    if (!modlopen) {
      setmodelValues((prev) =>
        !prev.rejectionReason && !prev.rejectionNote
          ? prev
          : { ...prev, rejectionReason: '', rejectionNote: '' }
      );
    }
  }, [modlopen]);

  useEffect(() => {
    if (isFiltering) {
      handleFiltering();
      setIsFiltering(false);
    }
  }, [isFilterOpen, isFiltering, data, values, filteredData]);

  function handleSubmit(event) {
    event.preventDefault();
    setIsFiltering(true);
  }
  return {
    pageLoading,
    billActionInFlight,
    filteredData,
    handleNew,
    modelvalues,
    setmodelValues,
    setOpenModel,
    modlopen,
    handlemodelvalues,
    handleMallChange,
    handleMallChangefilter,
    mallList,
    storeList,
    error,
    approveBillManagement,
    rejectBillManagement,
    setrejectStatus,
    rejectStatus,
    totalNumber,
    currentPage,
    setCurrentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    fetchBillData,
    isFiltering,
    billrejectReson,
    billrejectReasonDropdown,
  };
};

export default useBillManagement;
